import React, { Component } from "react";
import { connect } from "react-redux";
import {
  Button,
  Overlay,
  OverlayTrigger,
  Popover,
  Tooltip,
  Row,
  Col,
} from "react-bootstrap";
import {
  handleTimesheetChange,
  handleTimeEntryChange,
  getProjectFromList,
  getEntriesByProjectId,
  deleteRow,
  setOvertimeEntries,
  setTimesheetDurations,
  handleEntryRemarks,
  NEW,
  DRAFT,
  PENDING,
  REJECTED,
  APPROVED,
  WORK_HOURS,
  deleteAdditionalRow,
} from "../../store/actions/timesheet/timesheetActions";
import {
  getProject,
  resetProject,
  getProjectsJSON,
} from "../../store/actions/projects/projectsActions";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import { Cache } from "aws-amplify";
import {
  MANAGER,
  PROJECT_SPONSOR,
} from "../../store/actions/users/usersActions";
import {
  ERROR_ALERT,
  toggleShowAlert,
} from "../../store/actions/commonActions";
import { fetchMemberProjects } from "../../store/actions/projects/projectMembersActions";
import {
  fetchHolidays,
  isHoliday,
} from "../../store/actions/holidays/holidaysActions";

import Select from "react-select";
import moment from "moment";

class TimesheetForm extends Component {
  constructor(props) {
    super(props);
    this.project = "";
    this.weeklySpentHours = 0;
    this.projectTasks = [];
    this.status = "";
    this.action = "";
    this.selectedValues = [];
    this.onOTLeaveTimeOut = "";
    this.onRemarksLeaveTimeOut = "";
    this.inComponentReadOnly = false;

    this.chargeClass = "actualTimeCharges";
    this.remainClass = "remainingBudgetHours";
    this.weeklyHours = "weeklySpentHours";
    this.timeEntryClass = "time-entry-duration";
    this.timeEntryOTClass = "time-entry-duration time-entry-duration-ot";
    this.timeEntryText = "time-entry-text";
    this.timeEntryOTText = "time-entry-ot-text";

    this.requestorId = 0;
    this.memberHours = {};
    this.entriesByProject = {};
    this.selectClass = "timesheetSelect";

    this.refetched = false;
  }

  async componentDidMount() {
    const userId = Cache.getItem("userId");
    await this.props.fetchHolidays();
    this.props.fetchMemberProjects(userId, {
      is_disabled: 0,
      status: APPROVED,
    });

    //if not approver, requestor is usually the current user
    if (this.props.action !== "TIMESHEET_APPROVAL") {
      this.requestorId = Cache.getItem("userId");
    }
    Cache.setItem("hideOTPopoverOnLoad", true);
  }

  enableSubmitButton = () => {
    const submitButton = document.getElementById("submitButton");
    if (submitButton) {
      submitButton.disabled = false;

      const timesheetEntries = this.props.timesheets.timesheetEntries;
      if (timesheetEntries && timesheetEntries.length) {
        timesheetEntries.forEach((entry) => {
          if (!entry.project_id || !entry.task_id) {
            submitButton.disabled = true;
            return true;
          }
        });
      }

      const durationEntries = this.props.timesheets.durationEntries;
      const overtimeEntries = this.props.timesheets.overTimeEntries;

      if (durationEntries && durationEntries.length) {
        let durationPerDay = {};
        let durationPerTask = {};

        durationEntries.forEach((entry) => {
          if (entry.duration < 0) {
            submitButton.disabled = true;
            return true;
          }

          if (!(entry.date in durationPerDay)) {
            durationPerDay[entry.date] = 0;
          }
          if (!(entry.entry_id in durationPerTask)) {
            durationPerTask[entry.entry_id] = 0;
          }

          durationPerDay[entry.date] =
            durationPerDay[entry.date] + +entry.duration;
          durationPerTask[entry.entry_id] =
            durationPerTask[entry.entry_id] + +entry.duration;
        });

        for (const entryId in durationPerTask) {
          if (+durationPerTask[entryId] <= 0) {
            submitButton.disabled = true;
            return true;
          }
        }

        let taggedOTs = [];

        for (const date in durationPerDay) {
          const thisMoment = moment(date);
          const isWeekend = thisMoment.day() === 0 || thisMoment.day() === 6;
          const isHoliday = this.props.isHoliday(date);

          if (
            thisMoment.isSameOrBefore(moment()) &&
            !isWeekend &&
            !isHoliday &&
            +durationPerDay[date] < WORK_HOURS
          ) {
            submitButton.disabled = true;
            return true;
          }

          //if more than 8 hours check if they tag an entry as OT.
          if (
            +durationPerDay[date] > WORK_HOURS ||
            ((isWeekend || isHoliday) && +durationPerDay[date] > 0)
          ) {
            let isTag = false;
            if (overtimeEntries.length) {
              overtimeEntries
                .filter((data) => {
                  if (data.entryDate === date) {
                    return data;
                  }
                  return null;
                })
                .forEach((data) => {
                  //at least has one tagged OT for more than 8 hours entry for the day
                  if (data.isTag) {
                    isTag = true;
                    taggedOTs.push(true);
                  }
                });

              if (!isTag) {
                taggedOTs.push(false);
              }
            }
          }
        }

        if (taggedOTs.includes(false)) {
          submitButton.disabled = true;
          return true;
        } else {
          submitButton.disabled = false;
          return true;
        }
      }
    }

    return false;
  };

  showAddRemarks = (timeDurations, date, entryId) => {
    timeDurations =
      timeDurations.length &&
      timeDurations.map((timeDuration) => {
        if (
          timeDuration.date === date.shortHandDate &&
          timeDuration.entry_id === entryId &&
          parseFloat(timeDuration.duration) > 0
        ) {
          timeDuration.addingRemarks = true;
        }

        return timeDuration;
      });

    this.props.setTimesheetDurations(timeDurations);
  };

  hideAddRemarks = (timeDurations, date, entryId) => {
    timeDurations =
      timeDurations.length &&
      timeDurations.map((timeDuration) => {
        if (
          timeDuration.date === date.shortHandDate &&
          timeDuration.entry_id === entryId
        ) {
          timeDuration.addingRemarks = false;
        }

        return timeDuration;
      });

    this.props.setTimesheetDurations(timeDurations);
  };

  getTotalDayHours = (date) => {
    let timeDurations = this.props.timesheets.durationEntries;
    let totalHours = 0;

    timeDurations
      .filter((data) => {
        if (data.date === date.shortHandDate) {
          return data;
        }
        return null;
      })
      .forEach((timeDuration) => {
        totalHours += parseFloat(timeDuration.duration);
      });

    return totalHours;
  };

  getTotalOTHours = (date) => {
    let overtimeEntries = this.props.timesheets.overTimeEntries;
    let totalOTHours = 0;

    overtimeEntries
      .filter((data) => {
        if (data.entryDate === date.shortHandDate) {
          return date;
        }
        return null;
      })
      .forEach((overtimeEntry) => {
        if (typeof overtimeEntry.otHours !== "undefined") {
          totalOTHours += overtimeEntry.otHours;
        }
      });

    return totalOTHours;
  };

  updateOTHours = (date, otHours) => {
    let overTimeEntries = this.props.timesheets.overTimeEntries;

    overTimeEntries = overTimeEntries.map((otEntry) => {
      if (
        otEntry.entryDate === date.shortHandDate &&
        otEntry.entryId === this.props.entry_id
      ) {
        otEntry.isTag = true;
        otEntry.otHours = otHours;
      }
      return otEntry;
    });

    this.props.setOvertimeEntries(overTimeEntries);
  };

  generateTimeEntries = () => {
    let rows = [];
    let status = "";
    let weeklySpentHours = 0;

    var currDate = new Date();
    currDate.setDate(currDate.getDate());
    const timesheetDates = this.props.timesheets.timesheetDates;
    const timesheet = this.props.timesheets.timesheet;
    const timesheetEntries = this.props.timesheets.timesheetEntries;

    let timeDurations = this.props.timesheets.durationEntries;
    let overTimeEntries = this.props.timesheets.overTimeEntries;

    let arrOTEntries = [];

    overTimeEntries.length &&
      overTimeEntries.forEach((overTimeEntry) => {
        arrOTEntries.push(overTimeEntry.entryDate);
      });

    let disabledEntries = 0;

    timesheetDates.forEach((date, key) => {
      let durationValue = 0;
      let projectStartDate = "";
      let projectEndDate = "";
      let timeEntryId = "";
      let showPopover = false;
      let otHours = "";
      let showAddRemarks = false;
      let remarks = "";

      timeDurations
        .filter((data) => {
          if (
            data.date === date.shortHandDate &&
            data.entry_id === this.props.entry_id
          ) {
            return data;
          }
          return null;
        })
        .forEach((timeEntry) => {
          durationValue = timeEntry.duration;
          remarks = timeEntry.remarks;
          showAddRemarks = timeEntry.addingRemarks;
        });

      if (timesheetEntries) {
        const project = timesheetEntries
          .filter((entry) => entry.entry_id === this.props.entry_id)
          .map((entry) => entry.project)
          .pop();
        if (project) {
          projectStartDate = new Date(project.start_date);
          projectEndDate = new Date(project.end_date);
        }
      }

      if (Object.keys(timesheet).length > 0) {
        status = timesheet.status;
      } else {
        status = NEW;
      }
      weeklySpentHours = weeklySpentHours + parseInt(durationValue);

      let overtimeEntry = {};

      overTimeEntries.length &&
        overTimeEntries
          .filter((data) => {
            if (
              data.entryDate === date.shortHandDate &&
              data.entryId === this.props.entry_id
            ) {
              return data;
            }
            return null;
          })
          .forEach((otEntry) => {
            overtimeEntry = otEntry;
          });

      let displayDuration = "";
      let disabledEntryField = false;
      let entryDate = new Date(date.shortHandDate);
      if (status !== PENDING) {
        if (
          entryDate > currDate ||
          (projectEndDate && entryDate > projectEndDate) ||
          (projectStartDate && entryDate < projectStartDate)
        ) {
          disabledEntryField = true;
        } else {
          disabledEntryField = false;
        }

        //disable time entries that doesn't reach the cut-off
        const currentDate = moment().date();
        const currentMonth = moment().month() + 1;
        const currentYear = moment().year();

        const entryMonth = moment(entryDate).month() + 1;
        const entryYear = moment(entryDate).year();

        if (status === APPROVED) {
          if (entryYear < currentYear) {
            disabledEntryField = true;
          } else {
            if (currentDate <= 15) {
              if (entryMonth < currentMonth && currentMonth - entryMonth > 1) {
                disabledEntryField = true;
              }
            } else {
              if (entryMonth < currentMonth) {
                disabledEntryField = true;
              }
            }
          }
        }

        if (disabledEntryField) {
          disabledEntries++;
        }

        timeEntryId = this.props.entry_id + "_" + date.shortHandDate;

        displayDuration = (
          <input
            type="text"
            readOnly={this.props.static}
            disabled={disabledEntryField}
            id={date.shortHandDate}
            uniqueId={timeEntryId}
            value={durationValue}
            className={
              overtimeEntry.isTag ? this.timeEntryOTClass : this.timeEntryClass
            }
            onChange={(e) => {
              this.props.handleTimeEntryChange(e, this.props.entry_id, () => {
                this.weeklySpentHours = +weeklySpentHours;
                let totalHours = this.getTotalDayHours(date);

                //remove OT Tag when total hours for the day is less than 8
                const isWeekend = date.day === "Sat" || date.day === "Sun";
                const isHoliday = this.props.isHoliday(date.shortHandDate);

                if (
                  totalHours <= 8 ||
                  (totalHours === 0 && (isWeekend || isHoliday))
                ) {
                  if (arrOTEntries.includes(date.shortHandDate)) {
                    overTimeEntries = overTimeEntries
                      .filter((data) => {
                        if (data.entryDate !== date.shortHandDate) {
                          return data;
                        }
                        return null;
                      })
                      .map((otEntry) => {
                        return otEntry;
                      });

                    this.props.setOvertimeEntries(overTimeEntries);
                  }
                }

                if (isHoliday) {
                  this.updateOTHours(date, e.target.value);
                }
              });

              if (typeof Cache.getItem("hideOTPopoverOnLoad") !== "undefined") {
                Cache.removeItem("hideOTPopoverOnLoad");
              }
            }}
            onMouseEnter={() => {
              if (!overtimeEntry.showPopover) {
                overTimeEntries = overTimeEntries.map((otEntry) => {
                  if (
                    otEntry.entryDate === date.shortHandDate &&
                    otEntry.entryId === this.props.entry_id
                  ) {
                    if (otEntry.isTag) {
                      otEntry.isUnTagging = true;
                    } else {
                      otEntry.isUnTagging = false;
                    }

                    otEntry.showPopover = true;
                  }

                  return otEntry;
                });

                this.props.setOvertimeEntries(overTimeEntries);
              }
            }}
            onClick={() => {
              timeDurations = this.props.timesheets.durationEntries;
              if (!showAddRemarks) {
                this.showAddRemarks(timeDurations, date, this.props.entry_id);
              } else {
                this.hideAddRemarks(timeDurations, date, this.props.entry_id);
              }
            }}
            onBlur={(e) => {
              let value = e.target.value;
              if (value) {
                if (value.includes(":")) {
                  e.target.value = +moment.duration(value).asHours().toFixed(2);
                } else {
                  value = parseFloat(value);
                  if (!isNaN(value)) {
                    e.target.value = +value.toFixed(2);
                  }
                }

                this.props.handleTimeEntryChange(e, this.props.entry_id);
              }

              this.onRemarksLeaveTimeOut = setTimeout(() => {
                timeDurations = this.props.timesheets.durationEntries;
                this.hideAddRemarks(timeDurations, date, this.props.entry_id);
              }, 300);
            }}
            onMouseLeave={() => {
              if (arrOTEntries.includes(date.shortHandDate)) {
                this.onOTLeaveTimeOut = setTimeout(() => {
                  //if the time entry is set to untagging, clicking out the input will remove the untagging state.
                  overTimeEntries = overTimeEntries.map((otEntry) => {
                    if (
                      otEntry.entryDate === date.shortHandDate &&
                      otEntry.entryId === this.props.entry_id
                    ) {
                      otEntry.showPopover = false;
                    }

                    return otEntry;
                  });

                  this.props.setOvertimeEntries(overTimeEntries);
                }, 100);
              }
            }}
            onFocus={() => {
              if (!arrOTEntries.includes(date.shortHandDate)) {
                overTimeEntries = overTimeEntries.map((otEntry) => {
                  if (otEntry.entryDate !== date.shortHandDate) {
                    otEntry.showPopover = false;
                  }

                  return otEntry;
                });

                this.props.setOvertimeEntries(overTimeEntries);
              }
            }}
          />
        );
      } else {
        if (overtimeEntry.isTag || remarks) {
          displayDuration = (
            <OverlayTrigger
              placement={"top"}
              overlay={
                <Tooltip id="tooltip-time-entry">
                  <div id="tooltip-time-entry-details">
                    {remarks ? "Remarks: " + remarks : ""}
                    {remarks && overtimeEntry.isTag ? (
                      <>
                        <br />
                        <br />
                      </>
                    ) : (
                      ""
                    )}
                    {overtimeEntry.otHours
                      ? "Overtime hours: " + overtimeEntry.otHours
                      : ""}
                  </div>
                </Tooltip>
              }
            >
              <div
                id={date.shortHandDate}
                className={
                  overtimeEntry.isTag
                    ? this.timeEntryText + " " + this.timeEntryOTText
                    : this.timeEntryText
                }
              >
                {durationValue}
              </div>
            </OverlayTrigger>
          );
        } else {
          displayDuration = (
            <div
              id={date.shortHandDate}
              className={
                overtimeEntry.isTag ? this.timeEntryOTText : this.timeEntryText
              }
            >
              {durationValue}
            </div>
          );
        }
      }

      this.status = status;

      if (
        arrOTEntries.includes(date.shortHandDate) &&
        durationValue > 0 &&
        overtimeEntry.showPopover
      ) {
        showPopover = true;
        otHours = overtimeEntry.otHours;
      }

      const isWeekend =
        moment(date.shortHandDate).day() === 0 ||
        moment(date.shortHandDate).day() === 6;
      const isHoliday = this.props.isHoliday(date.shortHandDate);

      rows.push(
        <td key={key} className="align-center">
          {displayDuration}
          {/* <Overlay
            target={
              document.querySelectorAll('[uniqueId="' + timeEntryId + '"]')[0]
            }
            show={showAddRemarks}
            placement="top"
          >
            <Popover
              id="popover-remarks"
              className="timesheet-popups"
              onClick={() => {
                clearTimeout(this.onRemarksLeaveTimeOut);
              }}
            >
              <Popover.Content>
                Enter Remarks
                <Form.Control
                  as="textarea"
                  className="mb-3"
                  rows={3}
                  id="timesheet-remarks"
                  value={remarks}
                  onChange={(e) => {
                    this.props.handleEntryRemarks(
                      e.target.value,
                      date,
                      this.props.entry_id
                    );
                  }}
                  onBlur={() => {
                    this.hideAddRemarks(
                      timeDurations,
                      date,
                      this.props.entry_id
                    );
                  }}
                />
              </Popover.Content>
            </Popover>
          </Overlay> */}
          <Overlay
            target={
              document.querySelectorAll('[uniqueId="' + timeEntryId + '"]')[0]
            }
            show={showPopover}
            placement="left"
          >
            <Popover
              id="popover-overtime"
              onMouseEnter={() => {
                //cancel time entry onMouseLeave event when mouse hover in Popover
                if (overtimeEntry.showPopover) {
                  clearTimeout(this.onOTLeaveTimeOut);
                }
              }}
              onMouseLeave={() => {
                //unshow popover when after mouse leave
                overTimeEntries = overTimeEntries.map((otEntry) => {
                  if (
                    otEntry.entryDate === date.shortHandDate &&
                    otEntry.entryId === this.props.entry_id
                  ) {
                    otEntry.showPopover = false;

                    if (!otEntry.otHours) {
                      otEntry.isTag = false;
                      otEntry.isUnTagging = false;
                    }
                  }

                  return otEntry;
                });

                this.props.setOvertimeEntries(overTimeEntries);
              }}
            >
              <Popover.Content>
                <Row>
                  <Col xs={7} sm={7} md={7} lg={7} xl={7}>
                    Enter OT hours:
                  </Col>
                  <Col xs={5} sm={5} md={5} lg={5} xl={5}>
                    <input
                      type="number"
                      className={this.timeEntryClass}
                      value={otHours}
                      onChange={(e) => {
                        //tagging OT
                        let otHours = parseFloat(e.target.value);

                        this.updateOTHours(date, otHours);

                        if (!isWeekend && !isHoliday) {
                          let totalDayHours = this.getTotalDayHours(date);
                          let totalOTHours =
                            +this.getTotalOTHours(date).toFixed(2);

                          let hoursToFile = 0;
                          if (totalDayHours > WORK_HOURS) {
                            hoursToFile = +(totalDayHours - WORK_HOURS).toFixed(
                              2
                            );
                          }

                          if (totalOTHours > hoursToFile) {
                            this.props.toggleShowAlert(
                              true,
                              ERROR_ALERT,
                              "Total overtime hours should be less than or equal to " +
                                hoursToFile +
                                " hours."
                            );
                            otHours = 0;

                            this.updateOTHours(date, otHours);
                          }
                          //ot hours should be less than or equal to actual hours
                          else if (otHours > durationValue) {
                            this.props.toggleShowAlert(
                              true,
                              ERROR_ALERT,
                              "Overtime hours should be less than or equal to actual time spent."
                            );

                            otHours = 0;
                            this.updateOTHours(date, otHours);
                          }
                        }
                      }}
                      onBlur={(e) => {
                        let otHours = parseFloat(e.target.value);

                        if (otHours === 0 || isNaN(otHours)) {
                          overTimeEntries = overTimeEntries.map((otEntry) => {
                            if (
                              otEntry.entryDate === date.shortHandDate &&
                              otEntry.entryId === this.props.entry_id
                            ) {
                              otEntry.isTag = false;
                              otEntry.isUnTagging = false;
                              otEntry.showPopover = false;
                              otEntry.otHours = "";
                            }

                            return otEntry;
                          });
                        }

                        this.props.setOvertimeEntries(overTimeEntries);
                      }}
                    />
                  </Col>
                </Row>
              </Popover.Content>
            </Popover>
          </Overlay>
        </td>
      );
    });

    if (disabledEntries > 0) {
      this.inComponentReadOnly = true;
    }

    return rows;
  };

  getProjectTasks = (projectTasks) => {
    let projectTasksList = "";
    if (projectTasks) {
      projectTasksList =
        projectTasks.length > 0 &&
        projectTasks.map((projectTask, key) => {
          let disabled = false;
          if (this.selectedValues.includes(projectTask.id)) {
            disabled = true;
          }

          return (
            <option key={key} value={projectTask.id} disabled={disabled}>
              {projectTask.name}
            </option>
          );
        });
    }

    return projectTasksList;
  };

  getProjectTasksJSON = (projectTasks) => {
    const entries = this.props.timesheets.timesheetEntries || [];

    let projectTasksList = "";
    if (projectTasks) {
      projectTasksList =
        projectTasks.length > 0 &&
        projectTasks.map((projectTask, key) => {
          return {
            key: key,
            value: projectTask.task_id,
            label: projectTask.name,
            isDisabled: entries
              .filter((entry) => entry.project_id === projectTask.project_id)
              .map((entry) => entry.task_id)
              .includes(projectTask.id),
          };
        });
    }

    return projectTasksList;
  };

  displayProjectField = (projectId, project) => {
    let projectName = "";
    let selectedValue = "";

    let projectsParams = {};
    projectsParams.includeGenAdmin = true;
    const selectedWeek = this.props.timesheets.selectedWeek;
    if (Object.keys(selectedWeek).length > 0) {
      projectsParams.sheetStartDate = selectedWeek.start;
      projectsParams.sheetEndDate = selectedWeek.end;
    }

    let projectsJSON = this.props.getProjectsJSON(projectsParams) || [];
    const genAdOption = [projectsJSON[0]];

    if (Object.keys(project).length > 0) {
      projectName = project.project_name;
    }

    if (projectsJSON.length && projectId) {
      selectedValue = projectsJSON.filter(
        (option) => option.value === projectId
      );
    }

    if (
      this.props.action === "ENTER_TIMESHEET" ||
      this.props.action === "UPDATE_TIMESHEET"
    ) {
      if (this.status === PENDING || this.props.readOnly) {
        return <span title={projectName}>{projectName}</span>;
      }

      return (
        <Select
          className={this.selectClass}
          classNamePrefix={this.selectClass}
          size="sm"
          value={selectedValue}
          isDisabled={this.props.static}
          onChange={(selectedOption) => {
            this.props.resetProject();
            this.props.getProject(selectedOption.value);
            this.props.handleTimesheetChange(
              null,
              this.props.entry_id,
              {
                id: "project_id",
                value: selectedOption.value,
              },
              this.props.formGroup
            );
            this.props.getProjectFromList(
              this.props.entry_id,
              selectedOption.value,
              this.props.formGroup
            );
          }}
          options={genAdOption}
        />
      );
    } else {
      return (
        <span className="pt-3" title={projectName}>
          {projectName}
        </span>
      );
    }
  };

  displayTaskField = (taskId, projectTasks) => {
    let taskName = "";
    let selectedValue = "";
    let tasksJSON = this.getProjectTasksJSON(projectTasks) || [];

    if (projectTasks) {
      if (projectTasks.length > 0) {
        taskName = projectTasks
          .filter((data) => {
            if (data.task_id === taskId) {
              return data;
            }
            return null;
          })
          .map((task) => {
            return task.name;
          });

        if (tasksJSON.length) {
          selectedValue = tasksJSON.filter((option) => option.value === taskId);
        }
      }
    }

    if (
      this.props.action === "ENTER_TIMESHEET" ||
      this.props.action === "UPDATE_TIMESHEET"
    ) {
      if (this.status === PENDING || this.props.readOnly) {
        return <span title={taskName}>{taskName}</span>;
      }

      return (
        <Select
          className={this.selectClass + " taskSelect"}
          classNamePrefix={this.selectClass}
          size="sm"
          value={selectedValue}
          isDisabled={this.props.static}
          onChange={(selectedOption) => {
            this.props.handleTimesheetChange(
              null,
              this.props.entry_id,
              {
                id: "task_id",
                value: selectedOption.value,
              },
              this.props.formGroup
            );
          }}
          options={tasksJSON}
        />
      );
    } else {
      return <span title={taskName}>{taskName}</span>;
    }
  };

  refetchMemberProjects = () => {
    const timesheets = this.props.timesheets;
    const timesheet = timesheets.timesheet;
    if (timesheet && timesheet.requestor && !this.refetched) {
      this.requestorId = +timesheet.requestor.id;
      //need to refresh if approving
      this.props.fetchMemberProjects(this.requestorId);
      this.refetched = true;
    }
  };

  getMemberHours = () => {
    const memberProjects = this.props.projects.memberProjects;
    if (memberProjects && memberProjects.length) {
      memberProjects.forEach((memberProject) => {
        if (this.requestorId === memberProject.user.id) {
          this.memberHours[memberProject.project_id] =
            +memberProject.user_budgeted_hours;
        }
      });
    }
  };

  fetchUserProjectHours = () => {
    if (!Object.keys(this.entriesByProject).length) {
      const memberHours = this.memberHours;
      if (memberHours) {
        const projectIds = Object.keys(memberHours);
        if (projectIds.length) {
          projectIds.forEach((projectId) => {
            if (!(projectId in this.entriesByProject)) {
              this.props.getEntriesByProjectId(projectId);
              this.entriesByProject[projectId] = {};
            }
          });
        }
      }
    }
  };

  getUserProjectHours = (projectId) => {
    const entries = this.props.timesheets.entriesByProject;
    if (
      Object.keys(entries).length &&
      projectId in entries &&
      entries[projectId].length &&
      this.requestorId
    ) {
      return entries[projectId]
        .filter(
          (entry) =>
            entry.status !== REJECTED &&
            entry.status !== DRAFT &&
            +entry.user_id === this.requestorId
        )
        .map((entry) => +entry.total_hours)
        .reduce((a, b) => +a + +b, 0);
    }

    return "";
  };

  render() {
    let project = {};
    let projectId = "";
    let taskId = "";

    const timesheets = [
      ...this.props.timesheets.timesheetEntries,
      ...this.props.timesheets.additionalTimeEntries,
    ];
    const roleId = Cache.getItem("roleId");
    const userId = Cache.getItem("userId");

    timesheets
      .filter((timeEntry) => {
        if (timeEntry.entry_id === this.props.entry_id) {
          return timeEntry;
        }
        return null;
      })
      .forEach((timeEntry) => {
        if (typeof timeEntry.project !== "undefined" && timeEntry.project) {
          //for PM, skip project not under that person
          if (
            this.props.action === "TIMESHEET_APPROVAL" &&
            (roleId === MANAGER || roleId === PROJECT_SPONSOR) &&
            (!timeEntry.project.project_manager ||
              timeEntry.project.project_manager.id !== userId) &&
            timeEntry.project.project_sponsor !== userId
          ) {
            return;
          }

          project = timeEntry.project;
          projectId = +timeEntry.project_id;
          taskId = timeEntry.task_id;
        }
      });

    if (
      this.props.action === "TIMESHEET_APPROVAL" &&
      (!project || !Object.keys(project).length)
    ) {
      return "";
    }

    let actualTimeCharges = "";
    let remainingBudgetHours = "";

    const projectTasks = project.project_tasks;
    if (this.props.action === "TIMESHEET_APPROVAL") {
      this.refetchMemberProjects();
    }
    this.fetchUserProjectHours();

    this.getMemberHours();
    let budgetedHours = this.memberHours[projectId] || "";

    //either sum the input boxes, or the printed numbers
    const entrySelector = "tr[entry='" + this.props.entry_id + "']";
    const weeklyHours =
      Array.from(document.querySelectorAll(entrySelector + " input"))
        .map((el) => +el.value)
        .reduce((a, b) => +a + +b, 0) ||
      Array.from(
        document.querySelectorAll(entrySelector + " div." + this.timeEntryText)
      )
        .map((el) => +el.textContent)
        .reduce((a, b) => +a + +b, 0) ||
      "";

    //only show if has budgeted hours. gen admin has no projected hours
    if (budgetedHours !== "") {
      actualTimeCharges = this.getUserProjectHours(projectId) || "";
      const totalWeekHours =
        Array.from(
          document.querySelectorAll("tr[project='" + projectId + "'] input")
        )
          .map((el) => +el.value)
          .reduce((a, b) => +a + +b, 0) || 0;

      remainingBudgetHours =
        budgetedHours - +actualTimeCharges - totalWeekHours;

      if (isNaN(remainingBudgetHours)) {
        remainingBudgetHours = "";
      }
    }

    this.selectedValues = Array.from(
      document.getElementsByClassName("tasklist")
    ).map((tasklist) => +tasklist.options[tasklist.selectedIndex].value);

    let deleteRowBtn = <td>&nbsp;</td>;
    let padded = "";

    if (
      (this.status === NEW ||
        this.status === DRAFT ||
        this.status === REJECTED ||
        this.status === APPROVED) &&
      !this.props.readOnly &&
      !this.props.static
    ) {
      //if this.inComponentReadonly is true, meaning there are entries that can't be changed, so we won't allow to remove it.
      if (
        this.inComponentReadOnly &&
        this.status === APPROVED &&
        !this.props.static
      ) {
        deleteRowBtn = <td>&nbsp;</td>;
      } else {
        deleteRowBtn = (
          <td className="d-flex align-items-center justify-content-center w-100">
            <Button
              size="sm"
              onClick={() => {
                if (this.props.formGroup === "init") {
                  this.props.deleteRow(this.props.entry_id);
                } else {
                  this.props.deleteAdditionalRow(this.props.entry_id);
                }
              }}
            >
              <FontAwesomeIcon icon={faTimes} />
            </Button>
          </td>
        );
      }
      padded = "pt-3";
    }

    //this.enableSubmitButton();
    const budgetVsActual =
      parseFloat(+actualTimeCharges).toFixed(2) +
      " / " +
      parseFloat(+budgetedHours).toFixed(2);
    const weeklyVsRemain =
      parseFloat(+weeklyHours).toFixed(2) +
      " / " +
      parseFloat(+remainingBudgetHours).toFixed(2);

    return (
      <>
        <tr project={projectId} entry={this.props.entry_id} className="p-0">
          {deleteRowBtn}
          <td width="22%">{this.displayProjectField(projectId, project)}</td>
          <td width="25%">{this.displayTaskField(taskId, projectTasks)}</td>
          <td width="12%" className={"align-center " + padded}>
            {budgetVsActual}
          </td>
          {this.generateTimeEntries(projectId)}
          <td
            width="12%"
            className={"align-center " + padded + " " + this.weeklyHours}
          >
            {weeklyVsRemain}
          </td>
        </tr>
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  projects: state.projects,
  timesheets: state.timesheets,
  holidays: state.holidays,
  common: state.common,
});

const mapDispatchToProps = (dispatch) => {
  return {
    handleTimesheetChange: (...args) =>
      dispatch(handleTimesheetChange(...args)),
    resetProject: (...args) => dispatch(resetProject(...args)),
    getProject: (...args) => dispatch(getProject(...args)),
    getProjectFromList: (...args) => dispatch(getProjectFromList(...args)),
    handleTimeEntryChange: (...args) =>
      dispatch(handleTimeEntryChange(...args)),
    deleteRow: (...args) => dispatch(deleteRow(...args)),
    deleteAdditionalRow: (...args) => dispatch(deleteAdditionalRow(...args)),
    getEntriesByProjectId: (...args) =>
      dispatch(getEntriesByProjectId(...args)),
    fetchMemberProjects: (...args) => dispatch(fetchMemberProjects(...args)),
    getProjectsJSON: (...args) => dispatch(getProjectsJSON(...args)),
    setOvertimeEntries: (...args) => dispatch(setOvertimeEntries(...args)),
    setTimesheetDurations: (...args) =>
      dispatch(setTimesheetDurations(...args)),
    handleEntryRemarks: (...args) => dispatch(handleEntryRemarks(...args)),
    toggleShowAlert: (...args) => dispatch(toggleShowAlert(...args)),
    fetchHolidays: () => dispatch(fetchHolidays()),
    isHoliday: (...args) => dispatch(isHoliday(...args)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(TimesheetForm);
